import { http } from "./Config";
import settings from "@/settings";
import axios from 'axios';

export default {
  
  list: () => {
    return http.get(
        settings.usuarioAutenticado.GET_PEDIDO +
        "?empresa=" +
        settings.usuarioAutenticado.EMPRESA +
        "&cliente=" +
        settings.usuarioAutenticado.CLIENTE
    );
  },

  save: (pedido) => {
    return http.post(
        settings.usuarioAutenticado.SET_PEDIDO +
        "?empresa=" +
        settings.usuarioAutenticado.EMPRESA +
        "&cliente=" +
        settings.usuarioAutenticado.CLIENTE,
      pedido
    );
  },

  getPDF: (idPedido) => {
    var url = "https://teccommerce.com.br" +
              settings.usuarioAutenticado.GET_PDF +
              "?empresa=" +
              settings.usuarioAutenticado.EMPRESA +
              "&cliente=" +
              settings.usuarioAutenticado.CLIENTE + 
              "&pedido=" +
              idPedido;
    return axios({
      url: url,
      method: 'GET',
      headers: {
        Authorization: 'Basic c3lzcGVkOkBzeXNwZWQ='
      },
      responseType: 'blob', // important
    })
  },

  getPDFFile: (idPedido) => {
    var url = "https://teccommerce.com.br/api/pedido" +
              "/" +
              settings.usuarioAutenticado.EMPRESA +
              "/" +
              settings.usuarioAutenticado.CLIENTE + 
              "/" +
              idPedido + ".pdf";
    
    return url;
  },
};
